export default __webpack_public_path__ + "static/commercial-interior-demolition-icon-a237e4f8e099f56415e7abeb45e6245a.png";